import React from "react";
import Hero from "../components/CourseHero";
import { BiCheck } from "react-icons/bi";
import RegisterCard from "../components/RegisterCard";
import InstructorCard from "../components/InstructorCard";
import Accordion from "../components/Accordion";
import CourseDetailsTop from "../components/courseDetails/courseDetailsTop";


const courseData = {
  title: "Stripe Integration Expert",
  image:
    "https://fiverr-res.cloudinary.com/t_main1,q_auto,f_auto/gigs/151901881/original/923907679e7ebd8574ef970f9876d19b5388c1ab.png",
  currentPrice: "TK 2750",
  originalPrice: "TK 5500",
  discount: "50% off",
  // timeLeft: "9 hours left at this price!",
  // guarantee: "30-Day Money-Back Guarantee",
  lifetimeAccess: "Full Lifetime Access",
};


const courseContentData = {
  totalSections: 3,
  totalLectures: 21,
  totalLength: "9h 30m total length", // Estimated based on detailed topics
  sections: [
    {
      title: "Customer Business Functionality",
      lectures: 8,
      length: "3hr 15min",
      lessons: [
        { title: "Customer Management", length: "30min" },
        { title: "Create and manage Stripe customer objects", length: "20min" },
        {
          title: "Link customers to application-specific user records",
          length: "25min",
        },
        {
          title: "Card Management: Add new cards via Stripe Elements/API",
          length: "30min",
        },
        { title: "Update and delete saved card information", length: "30min" },
        {
          title: "Bank Account Management: Add/update/delete bank accounts",
          length: "30min",
        },
        { title: "Checkout with card or bank account", length: "15min" },
        {
          title: "Deferred payment, cancellations, and refund workflows",
          length: "15min",
        },
      ],
    },
    {
      title: "Employee Business Functionality",
      lectures: 7,
      length: "3hr",
      lessons: [
        {
          title: "Stripe Connected Accounts: Express and Custom",
          length: "40min",
        },
        { title: "Enabling employee payouts", length: "20min" },
        {
          title: "Card Management for Employees: Add/update/delete",
          length: "30min",
        },
        {
          title: "Bank Management for Employees: Add/update/delete",
          length: "30min",
        },
        { title: "Receiving payments via saved card", length: "20min" },
        { title: "Receiving payments via linked bank", length: "20min" },
        { title: "Handling employee payouts and compliance", length: "20min" },
      ],
    },
    {
      title: "Admin Business Functionality",
      lectures: 6,
      length: "3hr 15min",
      lessons: [
        {
          title: "Managing customer payments (confirm, cancel, refund)",
          length: "40min",
        },
        {
          title: "Approve/reject service requests based on payment status",
          length: "30min",
        },
        {
          title: "Transfer salary to employees via card or bank",
          length: "30min",
        },
        { title: "Cancel or refund employee payouts", length: "30min" },
        {
          title: "Confirming completed employee payment flows",
          length: "30min",
        },
        {
          title: "Admin bank/card management & Stripe balance payouts",
          length: "35min",
        },
      ],
    },
  ],
};

const courseDescriptionHTML = `
    <div class="mx-auto bg-white p-6 rounded-lg border">
        <p class="mt-2 text-gray-700">
            This course is more than just Stripe integration — it’s a professional developer’s roadmap for building robust payment infrastructure and developer tools (SDKs) from scratch.
        </p>

        <h2 class="text-xl font-semibold text-gray-700 mt-4">Why Take This Course?:</h2>
        <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li><strong>Learn real-world payment engineering with Stripe — not just theory</li>
            <li>Build a production-ready backend API with Node.js, Sequelize, and Stripe</li>
            <li>Gain experience in SDK development, highly valued in API engineering</li>
            <li>Delivering financial systems that are both user-friendly and auditable</li>
            <li>Handle real-world challenges: concurrency, identity verification, refund workflows</li>
            <li>Create a project portfolio that stands out to freelance clients or tech companies</li>
        </ul>

        <h2 class="text-xl font-semibold text-gray-700 mt-4">Boost Your Career By:</h2>

        <ul class="list-disc ml-5 mt-2 text-gray-700">
            <li>Adding advanced SDK development to your resume</li>
            <li>Understanding real fintech workflows used in startups and enterprises</li>
            <li>Learning production-grade patterns for building SDKs used by others</li>
        </ul>


        <h2 class="text-xl font-semibold text-gray-700 mt-4">What Types of Applications Need This Skill:</h2>
        <p class="font-semibold text-gray-700 mt-4">These skills are essential for developers building:</p>

        <ul class="list-disc ml-5 mt-2 text-gray-700">
         <h2 class="text-xl font-semibold text-gray-700 mt-4">1. eCommerce Applications</h2>    
            <li>Customers pay with cards or bank accounts</li>
            <li>Admins manage transactions, refunds, and view balances</li>
        </ul>

        <ul class="list-disc ml-5 mt-2 text-gray-700">
         <h2 class="text-xl font-semibold text-gray-700 mt-4">2. Marketplace Platforms</h2>    
            <li>Buyers make purchases</li>
            <li>Sellers or employees get payouts via Stripe Connected Accounts</li>
            <li>Admins handle disputes, refunds, and transfers</li>
        </ul>

        <ul class="list-disc ml-5 mt-2 text-gray-700">
         <h2 class="text-xl font-semibold text-gray-700 mt-4">3. SaaS Billing Platforms</h2>    
            <li>Users subscribe to services with saved payment methods</li>
            <li>Admins track billing, handle upgrades/cancellations</li>
        </ul>
        <ul class="list-disc ml-5 mt-2 text-gray-700">
         <h2 class="text-xl font-semibold text-gray-700 mt-4">4. Payroll & HR Applications</h2>    
            <li>Contractors or employees get paid through bank/card payouts</li>
            <li>Admins manage salaries, taxes, and payment schedules</li>
        </ul>

    
        <ul class="list-disc ml-5 mt-2 text-gray-700">
         <h2 class="text-xl font-semibold text-gray-700 mt-4">5. Custom Internal Tools / SDKs</h2>    
            <li>Companies building reusable SDKs to streamline Stripe usage internally</li>
            <li>Teams who want centralized code for handling payments and account logic</li>
        </ul>

        <h2 class="text-xl font-semibold text-gray-700 mt-4">Industry Roles You Can Aim For</h2>
        
        <ul class="list-disc ml-5 mt-2 text-gray-700">
         <h2 class="text-xl font-semibold text-gray-700 mt-4">1. Backend Developer (Fintech Focus)</h2>    
            <li>Specialize in building and integrating secure, scalable payment systems</li>
            <li>Manage customer accounts, payouts and financial flows</li>
            <li>Work with payment gateways like Stripe </li>
         <h2 class="text-xl font-semibold text-gray-700 mt-4">🛠 Skills Gained:</h2>    
            <li>API</li>
            <li>Payment system integration</li>
            <li>Error handling and transaction safety</li>
        </ul>
                <ul class="list-disc ml-5 mt-2 text-gray-700">
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">2. SDK/Library Engineer</h2>
                  <li>Design, develop, and maintain internal or public SDKs used by other developers</li>
                  <li>Build reusable, modular, and versioned codebases</li>
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">🛠 Skills Gained:</h2>
                  <li>SDK versioning (v1, v2, etc.)</li>
                  <li>Design patterns (Factory, Singleton, Strategy)</li>
                  <li>API wrappers and extensible module design</li>

                  <h2 class="text-xl font-semibold text-gray-700 mt-4">3. Full Stack Developer (Product-Oriented)</h2>
                  <li>Build applications that involve user payments, employee onboarding, and admin dashboards</li>
                  <li>Integrate the SDK with frontends for payment status and reports</li>
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">🛠 Skills Gained:</h2>
                  <li>End-to-end understanding of the payment lifecycle</li>
                  <li>Frontend-backend coordination</li>
                  <li>Secure UI + API development practices</li>

                  <h2 class="text-xl font-semibold text-gray-700 mt-4">4. API Integration Specialist</h2>
                  <li>Work with client teams to help them integrate Stripe and other payment APIs using your SDK</li>
                  <li>Tailor and deploy your SDK as part of client onboarding</li>
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">🛠 Skills Gained:</h2>
                  <li>SDK customization and API abstraction</li>
                  <li>API documentation and client SDK distribution</li>
                  <li>Real-world scenario handling (payments etc.)</li>

                  <h2 class="text-xl font-semibold text-gray-700 mt-4">5. Technical Product Engineer (Payments/Payroll Platforms)</h2>
                  <li>Drive feature development and architecture for payment workflows in platforms like payroll, HR tech, or eCommerce</li>
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">🛠 Skills Gained:</h2>
                  <li>Business-driven backend architecture</li>
                  <li>Secure handling of money flow</li>
                  <li>Operational tools (transfer/payout tracking, balance reports)</li>

                  <h2 class="text-xl font-semibold text-gray-700 mt-4">6. Fintech Software Engineer</h2>
                  <li>Be part of startups or large fintech companies building platforms that move real money securely</li>
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">🛠 Skills Gained:</h2>
                  <li>Stripe Connect and multi-party payouts</li>
                  <li>Scalable, testable, error-resilient SDK development</li>
                </ul>
              <ul class="list-disc ml-5 mt-2 text-gray-700">
                  <h2 class="text-xl font-semibold text-gray-700 mt-4">Bonus: Freelance & Entrepreneurship Opportunities</h2>
                  <li>Freelancers can build Stripe-integrated solutions faster using your SDK</li>
                  <li>Startup founders can create a fully functional payment system from day one</li>
                  <li>Consultants can offer plug-and-play SDKs for companies needing rapid integration</li>
              </ul>

                  <ul class="list-disc ml-5 mt-2 text-gray-700">
     

      <!-- Additional Stripe Concepts -->
      <h2 class="text-xl font-semibold text-gray-700 mt-4">📚 Additional Skills & Stripe Concepts Covered</h2>
      <li>Deep practical understanding of Stripe’s API and architecture</li>
      <li>Working with Stripe Customer API, Connect API, External Account Management</li>
      <li>Creating and managing Payment Intents, Setup Intents, and Transfer Objects</li>
      <li>Using Webhooks to handle async events like payment success/failure or payouts</li>
      <li>Ensuring PCI-compliant and secure payment flows</li>
      <li>Designing multi-role architecture (Customer, Employee, Admin)</li>
      <li>Building reliable retry logic and error handling for Stripe operations</li>

      <!-- Audience -->
      <h2 class="text-xl font-semibold text-gray-700 mt-4">👤 Who Is This Course For?</h2>
      <li>Backend Developers learning financial integrations</li>
      <li>Freelancers adding Stripe to client projects</li>
      <li>Startup developers building payment infrastructure</li>
      <li>Students building SaaS/Marketplace platforms</li>
      <li>Engineers preparing for roles that require Stripe, Node.js, or financial tech skills</li>
    </ul>



    </div>`;

const CourseDetails = () => {
  return (
    <>
      <Hero
        heading={"Become a Stripe Integration Expert"}
        subHeading={
          "Master Stripe payments, Bank/Card Transfer, Payout, subscriptions and webhooks with best practices."
        }
        author={"Mohammad Easin"}
        lastUpdate={"05/07"}
      />

      <div className="py-10 md:py-20 px-5 md:px--0 flex flex-col-reverse md:flex-row gap-5 container">
        {/* main section */}


        <div className="md:w-8/12">

          <section className="bg-white sm:px-6">
            <div className="max-w-6xl mx-auto border py-5 px-5">
              <h2 className="flex justify-between items-center text-green-600">Comming Soon......</h2>
            </div>

            <div className="relative isolate overflow-hidden bg-white py-5 sm:py-5 lg:py-5 shadow-sm">
              <div className="text-center">
                <div className="inline-flex items-center gap-3 justify-center bg-red-100  text-red-700 px-4 py-3 rounded-xl shadow-md">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M12 9v2m0 4v2m-6 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <h2 className="text-xl sm:text-2xl font-semibold">
                    If you're a junior developer, you're in the right place to grow fast and smart.
                  </h2>
                </div>
              </div>
            </div>
           
          </section>

       
          <CourseDetailsTop/>
          {/* what will you learn  */}
          <section className="bg-white text-gray-800 py-10 px-6 border border-gray-200 rounded-md max-w-5xl mx-auto">
            
            <h2 className="text-2xl font-bold mb-6">What you'll learn</h2>

            <div className="space-y-5">
              <h4 className="flex items-start text-2xl">
                <BiCheck className="size-9 text-blue-600 mt-1 mr-2 shrink-0" />
                <span>Stripe Payment Integration:</span>
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <ul className="space-y-3 ml-7">
                  <li className="flex items-start ">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Stripe Payments, Connect, Payouts, Webhooks</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>One-time and recurring card payments</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>ACH bank transfers and direct payouts</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Stripe Connect accounts (Standard, Express, Custom)
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Identity verification (KYC/AML)</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Secure card and bank account management</span>
                  </li>
                </ul>

                <ul className="space-y-3">
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Service booking-to-payout workflows</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Payment state management with Webhooks</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Storing transactions in MySQL (via Sequelize)</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Real-time payment feedback and notifications</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* learning two  */}
            <div className="space-y-5 mt-5">
              <div className="flex items-start text-2xl flex-col">
                <div className="flex">
                  <BiCheck className="size-9 text-blue-600 mt-1 mr-2 shrink-0" />
                  <span>SDK Architecture & Development:</span>
                </div>
                <h5 className="ml-12 font-medium text-[16px]">
                  Students will also gain valuable experience designing and
                  developing their own extensible SDK architecture for Stripe Or
                  Others using OODP and Software Design Patterns.{" "}
                </h5>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <ul className="space-y-3 ml-7">
                  
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Create versioned SDK modules for scalable, maintainable
                      APIs, reusable utility modules, centralized config, token
                      handling
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      API versioning (v1, v2) and backwards compatibility
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Handle API communication using centralized HTTP request
                      handlers
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>DRY, clean, and testable code</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Hot-reloading, memory monitoring, and restart protection
                    </span>
                  </li>
                </ul>

                <ul className="space-y-3">
                 
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Initialization & Configuration</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Lazy Service Loading</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Service Safety</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Strict Config Management</span>
                  </li>

                  <li className="flex items-start ">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Object-Oriented Programming: abstraction, inheritance,
                      encapsulation, polymorphism
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Design Patterns: Factory, Singleton, Strategy, Adapter
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* learning three */}
            <div className="space-y-5 mt-5">
              <div className="flex items-start text-2xl flex-col">
                <div className="flex">
                  <BiCheck className="size-9 text-blue-600 mt-1 mr-2 shrink-0" />
                  <span>Real-World Engineering Skills:</span>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <ul className="space-y-3 ml-7">
                  <li className="flex items-start ">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Building secure, scalable, audit-ready payment flows
                    </span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Understand when and how to abstract complex APIs into
                      simple, reusable SDKs
                    </span>
                  </li>
                  {/* <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Handling concurrency, refunds, and multi-role logic
                    </span>
                  </li> */}
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Writing extensible SDKs similar to Stripe’s official
                      libraries
                    </span>
                  </li>
                  {/* <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Understanding financial compliance (PCI, KYC)</span>
                  </li> */}
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Clean architecture and modular design</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Separation of concerns</span>
                  </li>
                </ul>

                <ul className="space-y-3">
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Centralized API communication</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Retry logic and error handling</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Secure token handling</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>Extensible utility layers</span>
                  </li>
                  <li className="flex items-start">
                    <BiCheck className="w-5 h-5 text-blue-600 mt-1 mr-2 shrink-0" />
                    <span>
                      Implement API versioning to future-proof your SDK (e.g.,
                      v1, v2)
                    </span>
                  </li>
                 
                </ul>
              </div>
            </div>
          </section>

          {/* Course Content  */}
          <div className="mt-5">
            <h2 className="text-xl font-bold mb-4 pl-0">
              Business Functionality
            </h2>
            <div className="mb-4">
              <span
                className="flex justify-between
               items-center"
              >
                <span>
                  {courseContentData.totalSections} sections •{" "}
                  {courseContentData.totalLectures} lectures
                </span>
                <span className="font-bold text-purple-700">
                  {courseContentData.totalLength}
                </span>
              </span>
            </div>

            <div className="">
              {courseContentData.sections.map((section, index) => (
                <Accordion
                  key={index}
                  title={section?.title}
                  info={section?.length}
                  items={section?.lessons}
                />
              ))}
            </div>
          </div>

          {/* Course Content  */}
          <div className="mt-5">
            <h2 className="text-xl font-bold mb-4 pl-0">Description</h2>
            <div
              className="mt-4"
              dangerouslySetInnerHTML={{ __html: courseDescriptionHTML }}
            />
          </div>

          <InstructorCard  />
        
        </div>

        {/* side bar */}
        <div className="relative">
          <RegisterCard data={courseData} />
        </div>
      </div>
      <div></div>
    </>
  );
};

export default CourseDetails;
